<template>
	<div class="full-height-container">
		<div id="rispose-embed"></div>
		<div
			v-if="error"
			class="error content"
		>
			<h3>Sorry, there was an error loading RealBot.</h3>
			<p>Please ensure you're connected to the internet.</p>
			<p>
				Refresh the page, and if the problem persists, email
				<a href="mailto:tech@realschools.com.au">tech@realschools.com.au</a>.
			</p>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		agentId: {
			type: String,
			default: '',
		},
		// Used to keep the agent history
		// Is typically a user ID
		threadId: {
			type: Number,
			default: 0,
		},
	},
	emits: ['loaded'],
	data() {
		return {
			agentIdInternal: '',
			agent: null as Rispose.Agent | null,
			Agents: null as Rispose.Agents | null,
			error: false,
		};
	},
	expose: ['restart', 'send'] as string[],
	beforeMount() {
		if (this.$route.params.agentId) {
			this.agentIdInternal = this.$route.params.agentId as string;
		}

		if (this.agentId) {
			this.agentIdInternal = this.agentId;
		}
	},
	async mounted() {
		try {
			// We use CloudFlare Workers to proxy the rispose.js file to avoid firewall issues
			// that we've had with some schools.
			const rispose = await import('https://static.realschools.com.au/rispose.js');
			this.Agents = rispose.Agents;
			this.handleAgentLoading();
		} catch (error) {
			this.error = true;
			this.$emit('loaded', null);
			console.error('Error loading Rispose SDK', error);
		}
	},
	unmounted() {
		this.agent?.remove();
		this.agent = null;
	},
	methods: {
		restart() {
			this.agent?.clear();
		},
		handleAgentLoading() {
			if (this.agent) {
				return;
			}

			// Don't think this can get here, but just in case and for typing
			if (!this.Agents) {
				console.error('Agents is not loaded');
				this.error = true;
				return;
			}

			try {
				this.agent = this.Agents.get(this.agentIdInternal);
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
			} catch (error) {
				// If it can't find the agent, it means it hasn't been created yet.
				// not sure why it throws an error tho
			}

			if (this.agent) {
				return;
			}

			this.agent = this.Agents.create(this.agentIdInternal, {
				client_id: this.threadId.toString(),
				// Force embed type for all bots (as some are set to tbe chat widgets in the LMS)
				type: 'embed',
			});

			this.$emit('loaded', this.agent);
		},
		send(prompt: string) {
			this.agent?.send(prompt);
		},
	},
});
</script>

<style scoped lang="scss">
.full-height-container {
	min-height: 500px;
}

.error {
	margin: 20px;
	border: 1px solid rgb(var(--rs-color-status-error));
	border-radius: 5px;
	background-color: rgb(var(--rs-color-status-error-light));
	padding: var(--rs-layout-content-padding);
	color: rgb(var(--rs-color-status-error));
}
</style>
